<template>
<div class="job-poster-management">
  <TableList
    class="job-poster-list"
    noPagination
    dragSortIcon="iconfont iconMore"
    :title="$t(`${i18nPrefix}.title.jobPosterManagement`)"
    :listData="listData"
    :tableColumns="tableColumns"
    :actionBtn="actionBtn"
    :showCreateBtn="false"
    @dragSort="changeSort"
  >
    <template #filter>
      <div class="header-left">
        <span class="text">{{ $t(`${i18nPrefix}.label.companyName`) }}</span>
        <span class="company-select">
          <el-select v-model="selectCompany" filterable @change="handleCompanySelect">
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="isEn() ? item.name : item.cn_name"
              :style="{'padding-left':item.level*15+'px'}"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </span>
      </div>
    </template>
    <template #btn-before>
      <div class="btn-group">
        <el-button v-if="hasAmbassadorPosterPremium" class="blue-btn" @click="addAmbassador">{{ $t(`${i18nPrefix}.title.jobPosterAmbassadorUpload`) }}</el-button>
        <el-button v-if="hasImagePosterPremium" class="cancel-btn blue-btn" @click="addPoster('img')">
          {{ $t(`${i18nPrefix}.label.add`) + $t(`${i18nPrefix}.label.imgPoster`) }}
        </el-button>
        <el-dropdown v-if="hasVideoPosterPremium && videoPosterTypeList && videoPosterTypeList.length" class="video-poster-type save-btn blue-btn" trigger="click" @command="addVideoPoster">
          <el-button class="dropdown-btn">
            <span>{{ $t(`${i18nPrefix}.label.add`) + $t(`${i18nPrefix}.label.videoPoster`) }}</span>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in videoPosterTypeList" :key="item.value" :command="item">{{ item.label }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </template>
    <template #link="{ row }">
      <a :href="row.link" target="_blank">{{ row.link }}</a>
    </template>
    <template #switchButton="{ row }">
      <div class="switch-container">
        <el-switch
          v-model="row.is_enabled"
          active-color="#13ce66"
          @change="changeStatus"
        >
        </el-switch>
      </div>
    </template>
    <template #posterName="{ row }">
      <div class="switch-container">
        <span>{{ $t(`${i18nPrefix}.label.${row.poster_type}Poster`) }}</span>
      </div>
    </template>
    <template #posterShowTypeName="{ row }">
      <div class="">
        <span>{{ $t(`${i18nPrefix}.jobPosterShowType.${row.show_type}`) }}</span>
      </div>
    </template>
  </TableList>
  <RectLoading v-show="showLoadingBox"/>
</div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import RectLoading from '@/components/loading/rectLoading'
import { isEn } from '@/i18n'
import { JOB_POSTER_SHOW_TYPE } from '@/constant/jobPoster'

export default {
  components: {
    TableList,
    RectLoading
  },
  data () {
    return {
      i18nPrefix: 'admin.company.jobPoster',
      isEn,
      showLoadingBox: false,
      listData: [],
      companyList: [],
      selectCompany: null,
      actionBtn: {
        edit: {
          show: true,
          onclick: this.handleEdit
        }
      },
      videoPosterType: null
    }
  },
  created () {
    this.initData()
  },
  computed: {
    tableColumns () {
      return [
        {
          label: this.$t(`${this.i18nPrefix}.label.posterTitle`),
          dataKey: 'title'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.posterType`),
          dataKey: 'name',
          slotName: 'posterName'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.jobPosterShowType`),
          dataKey: 'show_type',
          slotName: 'posterShowTypeName'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.isEnable`),
          dataKey: 'is_enabled',
          slotName: 'switchButton'
        },
        {
          label: this.$t('common.label.sortOperate'),
          isDragSort: true,
          width: '50px'
        }
      ]
    },
    hasVideoPoster () {
      return this.listData.find((item) => item.poster_type === 'video')
    },
    videoPosterTypeList () {
      const addTip = this.$t(`${this.i18nPrefix}.label.add`)
      const videoTip = this.$t(`${this.i18nPrefix}.label.videoPoster`)
      const list = _.map(JOB_POSTER_SHOW_TYPE, (val, key) => {
        return {
          label: `${addTip}${this.$t(`${this.i18nPrefix}.jobPosterShowType.${key}`)}${videoTip}`,
          value: val,
          hidden: this.listData.find((item) => item.show_type === val && item.poster_type === 'video') || key === 'INSTRUCTIONS' || (key !== 'COMMON' && !this.hasAmbassadorPosterPremium)
        }
      })

      return _.filter(list, item => !item.hidden)
    },
    hasAmbassadorPosterPremium () {
      return this.hasAnyPermission('PREMIUM_AMBASSADOR_POSTER')
    },
    hasImagePosterPremium () {
      return this.hasAnyPermission('PREMIUM_JOB_POSTER_IMAGE')
    },
    hasVideoPosterPremium () {
      return this.hasAnyPermission('PREMIUM_JOB_POSTER_VIDEO')
    }
  },
  methods: {
    ...mapActions('company', ['getJobPosterTypeList', 'updateJobPosterStatus', 'getCompanyChildrenTree']),
    addVideoPoster (item) {
      const hiddenVideoPosterShowTypeList = []
      _.forEach(JOB_POSTER_SHOW_TYPE, (val, key) => {
        const existPoster = this.listData.find((item) => item.show_type === val && item.poster_type === 'video')
        if (existPoster) {
          hiddenVideoPosterShowTypeList.push(val)
        }
      })
      const hiddenVideoPosterShowType = hiddenVideoPosterShowTypeList.join(',')
      const selectPosterShowType = item.value
      this.$router.push({
        name: 'jobPosterManagementEdit',
        params: {
          posterType: 'video'
        },
        query: {
          posterTypeId: 0,
          companyId: this.selectCompany,
          selectPosterShowType: selectPosterShowType,
          hiddenVideoPosterShowType: hiddenVideoPosterShowType
        }
      })
    },
    addAmbassador () {
      this.$router.push({ path: '/v-admin/job-poster-ambassador/list' })
    },
    formatCompanyData (data, company, companyList) {
      companyList.push(company)
      const allChildren = data.children
      const children = allChildren[company.id]
      if (children && children.length > 0) {
        for (const child of children) {
          this.formatCompanyData(data, child, companyList)
        }
      }
      return companyList
    },
    handleEdit (rowData) {
      this.$router.push({
        name: 'jobPosterManagementEdit',
        params: {
          posterType: rowData.poster_type
        },
        query: {
          posterTypeId: rowData.id,
          companyId: this.selectCompany
        }
      })
    },
    async initData () {
      this.showLoadingBox = true
      try {
        const companyTreeResp = await this.getCompanyChildrenTree()
        const currentCompany = {
          id: companyTreeResp.self.id,
          name: companyTreeResp.self.name,
          cn_name: companyTreeResp.self.cn_name,
          level: companyTreeResp.self.level
        }
        this.selectCompany = currentCompany.id
        const companyList = []
        this.companyList = this.formatCompanyData(companyTreeResp, currentCompany, companyList)
        const resp = await this.getJobPosterTypeList(this.selectCompany)
        this.listData = resp.list
      } finally {
        this.showLoadingBox = false
      }
    },
    async getPosterList () {
      this.showLoadingBox = true
      try {
        const resp = await this.getJobPosterTypeList(this.selectCompany)
        this.listData = resp.list
      } finally {
        this.showLoadingBox = false
      }
    },
    changeStatus () {
      this.updateData()
    },
    changeSort () {
      this.updateData()
    },
    async updateData () {
      const data = {
        poster_list: this.listData,
        company_id: this.selectCompany
      }
      this.updateJobPosterStatus(data)
    },
    handleCompanySelect () {
      this.getPosterList()
    },
    addPoster (posterType) {
      this.$router.push({
        name: 'jobPosterManagementEdit',
        params: {
          posterType
        },
        query: {
          posterTypeId: 0,
          companyId: this.selectCompany
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.job-poster-management {
  .job-poster-list {

    ::v-deep {
      .el-table {
        .drag-sort-icon {
          font-size: 24px;
          display: block;
        }

        .el-switch {
          display: flex;
        }
      }
    }

    .header-left {
      display: inline-block;
      vertical-align: middle;
      .text {
        margin-right: 10px;
        display: inline-block;
        vertical-align: middle;
      }

      .company-select {
        display: inline-block;
        vertical-align: middle;
      }
    }
    .btn-group {
      display: flex;
      justify-content: flex-end;
      .blue-btn {
        color: #0096cc;
      }

      .video-poster-type {
        margin-left: 10px;
      }
    }
  }
}

</style>
